<template>
  <responsive-drawer-layout v-if="dataLoaded" :isContentPdf="false">
    <template v-slot:drawer v-if="!hasGroupFilterInHeader">
      <v-chip-group class="ma-3" column active-class="primary--text" v-model="selectedGroup">
        <v-chip filter :value="group" v-for="group in groupsByInstance" :key="group.id" @click="mx_isLeftDrawerOpen = false">{{ group.name }} </v-chip>
      </v-chip-group>
    </template>

    <template v-slot:content>
      <div class="inherit-height scroll-container">
        <v-container :class="{ 'pa-1': $vuetify.breakpoint.xs, 'pa-2': $vuetify.breakpoint.smAndUp }" fluid>
          <v-row no-gutters>
            <v-col
              v-for="video in filteredAndSortedVideos"
              :key="video.id"
              cols="12"
              sm="6"
              md="4"
              lg="4"
              xl="3"
              :class="{ 'pa-1': $vuetify.breakpoint.xs, 'pa-2': $vuetify.breakpoint.smAndUp }"
            >
              <video-card objectFit="cover" :videoHeight="currentVideoHeight" :video="video" class="ma-0"></video-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </template>
  </responsive-drawer-layout>
  <div v-else class="d-flex justify-center align-center">
    <dots-loader></dots-loader>
  </div>
</template>

<script>
import ResponsiveDrawerLayout from '@/layouts/ResponsiveDrawerLayout';
import VideoCard from './VideoCard.vue';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import { mapState, mapGetters } from 'vuex';
import DotsLoader from '@/components/spinner/Dots';

export default {
  name: 'VideoBoard',
  mixins: [common, configMixin],
  components: {
    ResponsiveDrawerLayout,
    VideoCard,
    DotsLoader,
  },
  data() {
    return {
      currentVideoHeight: 200,
    };
  },
  created() {
    window.addEventListener('resize', this.resizeHandler);
    this.currentVideoHeight = this.videoHeight;
  },
  mounted() {
    this.interval = setInterval(() => {
      this.adjustVideoPreviewSize();
    }, 500);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  computed: {
    ...mapState('videos', ['videos', 'groups', 'dataLoaded']),
    ...mapGetters('videos', ['sortedAndFilteredGroups']),
    groupsByInstance() {
      return this.sortedAndFilteredGroups.filter((group) => group.instance == this.$route.params.instance);
    },
    moduleConfig() {
      let moduleConfig = this.getModuleConfig('Video', this.$route.params.instance);
      return moduleConfig;
    },
    videoWidth() {
      if (this.moduleConfig.videoWidth) {
        return this.moduleConfig.videoWidth;
      }
      return 200;
    },
    videoHeight() {
      if (this.moduleConfig.videoHeight) {
        return this.moduleConfig.videoHeight;
      }
      return 200;
    },
    videoAspectRatio() {
      return this.videoWidth / this.videoHeight;
    },
    selectedGroup: {
      get() {
        return this.$store.state.videos.selectedGroup;
      },
      set(value) {
        if (value !== this.$store.state.videos.selectedGroup) {
          this.$store.commit('videos/setSelectedGroup', value);
        }
      },
    },
    filteredAndSortedVideos() {
      return this.videos
        .filter((v) => v.instance == this.$route.params.instance)
        .filter((v) => {
          if (!this.selectedGroup) return true;
          return v.groupIdFk === this.selectedGroup.id;
        })
        .slice()
        .sort((v1, v2) => Number(v1.sort) - Number(v2.sort));
    },
    hasGroupFilterInHeader() {
      if (this.xs) return false;
      return this.groupsByInstance.length < 6;
    },
  },
  methods: {
    resizeHandler(e) {
      this.adjustVideoPreviewSize();
    },
    adjustVideoPreviewSize() {
      if (this.moduleConfig?.videoWidth && this.moduleConfig?.videoHeight) {
        var previewList = document.getElementsByClassName('video-preview');
        for (let i = 0; i < previewList.length; i++) {
          if (previewList[i] && previewList[i].clientWidth && previewList[i].clientHeight) {
            const previewWidth = previewList[i].clientWidth;
            const previewHeight = previewList[i].clientHeight;
            this.currentVideoHeight = Math.round(previewWidth / this.videoAspectRatio);
            previewList[i].height = this.currentVideoHeight;
          }
        }
      }
    },
  },
};
</script>
